class CIPProximityBlock {
    constructor() {}

    isProximity (proximityBlock) {
        if (!proximityBlock) {
            return {
                result: false,
                error: '[Error] The proximity block is not connected.',
            };
        }

        return new Promise(resolve => {
            setTimeout(() => {
                const result = proximityBlock.isProximity();
                resolve(result);
            }, 200);
        });
    }
}

export default CIPProximityBlock;
